import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const Qualifiers = () => {
    const dispatch = useDispatch();
    const [fetchError, setFetchError] = useState(null);

    return (
        <div className="mt-10 bg-white rounded-lg p-4 shadow-sm">
            <div className="flex justify-between items-center mb-4">
                <h2 className="font-display text-xl font-bold">Qualifiers</h2>
            </div>
            
            <div className="space-y-2">
                <div className="text-center text-gray-500 py-4">
                    Coming soon
                </div>
            </div>
        </div>
    );
};

export default Qualifiers;
